import { writable } from "svelte/store";
export const localStorageWritable = <T>(
	key: string,
	defaultValue: T,
	//If we change the type of a storage, we need to ensure the old type is not use
	//This function ensures the the old storage value is only used when it is the same type as the defaultValue
	isStorageOutdated?: (a: any, b: T) => boolean
) => {
	let store = writable(defaultValue);

	if (typeof window !== "undefined") {
		const unParsedValue = localStorage.getItem(key);
		const value = unParsedValue ? JSON.parse(unParsedValue) : null;

		if (value !== null && typeof value === typeof defaultValue) {
			if (isStorageOutdated && isStorageOutdated(value, defaultValue)) {
				store.set(defaultValue);
			}
		}

		store.subscribe((value) => {
			if (typeof window !== "undefined") {
				localStorage.setItem(key, JSON.stringify(value));
			}
		});
	}

	return store;
};
